
export class ImageCollectorDto {
    
    MobileModuleName = '';
    OrganizationName = '';
}
